import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientStopOfferContent のスタイル
 */
export const hotlineClientStopOfferContentStyle = tv({
    slots: {
        base: [
            textStyle({ color: 'base', size: 'xs' }),
            'flex items-center justify-between gap-16',
            'bg-orange-50',
            'p-16',
            'rounded-md',
        ],
        button: ['max-w-[148px]'],
    },
});
